import { useState } from 'react';

export default function Hero() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20cozy%20artistic%20reading%20atmosphere%2C%20soft%20natural%20window%20light%20falling%20on%20an%20open%20manga%20book%20with%20colorful%20illustrations%2C%20warm%20coral%20and%20amber%20tones%2C%20gentle%20artistic%20style%2C%20wooden%20table%20with%20bookshelves%20in%20soft%20bokeh%20background%2C%20editorial%20photography%20feel%2C%20high%20detail%2C%20harmonious%20warm%20composition%20with%20natural%20textures%20and%20organic%20shapes&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
        alt="香香漫画 - 温暖舒适的漫画阅读氛围"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-16">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-4 py-1.5 bg-accent-500/90 text-background-50 text-sm font-medium rounded-full mb-5 whitespace-nowrap">
              每日更新 热门连载
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-4">
              香香漫画 - 免费漫画大全，下拉式畅快追更
            </h1>

            <p className="text-lg md:text-xl text-white/85 font-heading mb-6">
              海量资源 · 每日更新 · 随时随地畅享阅读
            </p>

            <p className="text-sm md:text-base text-white/75 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              香香漫画为您提供全网最全的香香漫画大全免费阅读体验，香香漫画全集免费在线观看，支持香香漫画免费下拉式阅读。无论您喜欢热血、恋爱、悬疑还是搞笑漫画，这里都有好看的漫画免费全集等您来追。每日同步更新，无需等待，下拉即看，畅享无缝阅读体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10万+</div>
                <div className="text-xs text-white/65 mt-1">海量漫画资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
                <div className="text-xs text-white/65 mt-1">同步追更不停</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">全本免费</div>
                <div className="text-xs text-white/65 mt-1">无需付费订阅</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-base transition-all duration-200 whitespace-nowrap text-center cursor-pointer"
              >
                开始阅读
              </a>
              <a
                href="#app"
                className="w-full sm:w-auto px-8 py-3 bg-white/15 hover:bg-white/25 text-white border border-white/30 font-semibold rounded-full text-base transition-all duration-200 whitespace-nowrap text-center cursor-pointer backdrop-blur-sm"
              >
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 flex justify-center lg:justify-end w-full">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[460px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20manga%20illustration%20style%20composition%2C%20a%20beautiful%20dynamic%20character%20design%20with%20flowing%20hair%20and%20vibrant%20warm%20colors%2C%20soft%20dreamy%20lighting%2C%20coral%20rose%20and%20golden%20amber%20accents%2C%20watercolor%20and%20ink%20artistic%20style%2C%20elegant%20composition%2C%20clean%20minimal%20background%20with%20gentle%20gradients%2C%20warm%20and%20inviting%20aesthetic%2C%20high%20detail%20character%20art&width=680&height=920&seq=hero-side-manga-01&orientation=portrait"
                alt="香香漫画 - 精彩漫画角色主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-white/20 pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="fixed inset-0 z-40 bg-background-950/60 backdrop-blur-sm md:hidden" onClick={() => setMenuOpen(false)}>
          <div className="absolute top-20 right-4 bg-background-50 rounded-2xl p-4 w-56 shadow-lg" onClick={(e) => e.stopPropagation()}>
            <ul className="flex flex-col gap-1">
              {[
                { label: '首页', href: '#hero' },
                { label: '漫画分类', href: '#index' },
                { label: '热门排行', href: '#ranking' },
                { label: '平台特色', href: '#features' },
                { label: 'APP下载', href: '#app' },
                { label: '联系我们', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setMenuOpen(false)}
                    className="block px-3 py-2 text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
}